module.exports = __webpack_public_path__ + "static/media/1_03.5e6e2edf.png";